(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('stretchAssistantService', stretchAssistantService);

    stretchAssistantService.$inject = ['$http', 'CONFIG','messageService'];

    function stretchAssistantService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/stretchAssistants';

        var service = {
            getStretchAssistants: getStretchAssistants,
            getStretchAssistantsOrigin: getStretchAssistantsOrigin,
            getStretchAssistantsList: getStretchAssistantsList,
            search: search,
            searchIata: searchIata,
            searchDestiny: searchDestiny,
            searchDestinyIata: searchDestinyIata
        };

        return service;

        function getStretchAssistants(){
            return $http.get(urlBase)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getStretchAssistantsOrigin(id){
            return $http.get(urlBase + "/" + id + "/origin")
        }

        function getStretchAssistantsList(){
            return $http.get(urlBase + "/list")
        }

        function search(search){
            return $http.get(urlBase + "/origin/" + search, {headers: {'Loading-Overlay': false}})
        }

        function searchIata(search){
            return $http.get(urlBase + "/originIata/" + search, {headers: {'Loading-Overlay': false}})
        }
        function searchDestiny(originId,search){
            return $http.get(urlBase + "/" +originId + "/origin/" + search, {headers: {'Loading-Overlay': false}})
        }
        function searchDestinyIata(originId,search){
            return $http.get(urlBase + "/" +originId + "/originIata/" + search, {headers: {'Loading-Overlay': false}})
        }
    }
})();
